// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"tp_a bii_b bii_bj","SubscribedPhotoblogs__link":"tp_b bii_a bii_r"};